<template>
    <el-calendar v-loading="loading" ref="calendar">
        <template #date-cell="{data}">
            <div>{{ data.day.split('-').slice(1).join('-') }}</div>
            <div style="display: flex;flex-wrap: wrap">
                <img style="margin: 3px;width: 30px" :src="resourceUrl(i.thumbnail)"
                     v-for="i in data_map[data.day].slice(0, 10)" v-if="data_map[data.day]">
            </div>
            <el-tag v-if="data_map[data.day] && data_map[data.day].some(i => i.animation)" size="small" type="success">动图</el-tag>
        </template>
    </el-calendar>
    <div class="daily-toolbar">
        <date-range-picker v-model="form" :disabled="loading" clearable></date-range-picker>
        <el-button type="primary" :disabled="loading" @click="openImagePicker">选图</el-button>
    </div>
    <el-table v-loading="loading" :data="dataPage">
        <el-table-column label="ID" prop="id" width="130"></el-table-column>
        <el-table-column label="状态" prop="status" width="100">
            <template #default="scope">
                <el-select :disabled="loading" style="width: 80px" v-model="scope.row.status"
                           @change="update(scope.row)">
                    <el-option label="通过" value="AUDITED"></el-option>
                    <el-option label="审核中" value="AUDITING"></el-option>
                    <el-option label="不通过" value="REJECTED"></el-option>
                </el-select>
            </template>
        </el-table-column>
        <el-table-column label="图片" prop="resource" width="200">
            <template #default="scope">
                <el-image lazy :src="resourceUrl(scope.row.thumbnail)" style="width: 180px"/>
                <div style="text-align: center;">
                    <a :href="resourceUrl(scope.row.resource)" target="_blank">高清大图</a>
                </div>
            </template>
        </el-table-column>
        <el-table-column label="动图" prop="animation" width="140">
            <template #default="scope">
                <video v-if="scope.row.animation" :src="resourceUrl(scope.row.animation)" controls muted playsinline style="width: 120px"></video>
                <span v-else style="color: #999;">否</span>
            </template>
        </el-table-column>
        <el-table-column label="来源" prop="source" width="100"></el-table-column>
        <el-table-column label="上线时间" prop="online_date" width="140">
            <template #default="scope">
                <el-date-picker style="width: 120px" value-format="YYYY-MM-DD" v-model="scope.row.online_date"
                                @change="updateOnlineDate(scope.row)" :clearable="false"></el-date-picker>
            </template>
        </el-table-column>
        <el-table-column label="描述" prop="desc">
            <template #default="scope">
                <el-input v-model="scope.row.desc" @change="update(scope.row)" :disabled="loading"></el-input>
            </template>
        </el-table-column>
    </el-table>
    <div style="display: flex; justify-content: space-between">
        <el-pagination layout="prev, pager, next" :total="dataFilter.length" :page-size="size"
                       v-model:current-page="page" :disabled="loading"></el-pagination>
    </div>
    <el-dialog v-model="picker.opened" width="86%" title="选择每日更新图片">
        <div class="picker-filter">
            <el-input v-model="picker.query.id" prefix-icon="Search" @change="fetchPickerImages(1)"
                      placeholder="ID搜索" clearable style="width: 220px"></el-input>
            <el-select v-model="picker.query.category_ids" multiple clearable filterable collapse-tags
                       collapse-tags-tooltip placeholder="分类筛选" style="width: 220px"
                       @change="fetchPickerImages(1)">
                <el-option v-for="c in category_list" :key="c.id" :value="c.id"
                           :label="c.i18n_name.ZH_HANS"></el-option>
            </el-select>
            <el-select v-model="picker.query.is_animated" clearable placeholder="是否动图"
                       style="width: 130px" @change="fetchPickerImages(1)">
                <el-option label="动图" :value="true"></el-option>
                <el-option label="静图" :value="false"></el-option>
            </el-select>
            <el-cascader v-model="picker.query.major_tags" placeholder="主要标签" clearable filterable
                         :options="major_list" :props="tagProps" collapse-tags collapse-tags-tooltip
                         style="width: 300px" @change="fetchPickerImages(1)"></el-cascader>
            <el-cascader v-model="picker.query.minor_tags" placeholder="次要标签" clearable filterable
                         :options="minor_list" :props="tagProps" collapse-tags collapse-tags-tooltip
                         style="width: 300px" @change="fetchPickerImages(1)"></el-cascader>
            <el-cascader v-model="picker.query.assistant_tags" placeholder="辅助标签" clearable filterable
                         :options="assistant_list" :props="tagProps" collapse-tags collapse-tags-tooltip
                         style="width: 300px" @change="fetchPickerImages(1)"></el-cascader>
        </div>
        <el-table v-loading="picker.loading" :data="picker.images" style="margin-top: 10px">
            <el-table-column label="图片" width="180">
                <template #default="scope">
                    <el-image lazy :src="`${$root.cdn_url}/${scope.row.thumbnail}`"
                              style="width: 130px"></el-image>
                </template>
            </el-table-column>
            <el-table-column label="ID" prop="id" width="150"></el-table-column>
            <el-table-column label="动图" width="140">
                <template #default="scope">
                    <video v-if="scope.row.animation" :src="resourceUrl(scope.row.animation)"
                           controls muted playsinline style="width: 120px"></video>
                    <span v-else style="color: #999;">静图</span>
                </template>
            </el-table-column>
            <el-table-column label="模块" prop="module" width="100">
                <template #default="scope">
                    {{ moduleLabel(scope.row.module) }}
                </template>
            </el-table-column>
            <el-table-column label="分类" prop="categories" width="120">
                <template #default="scope">
                    <el-tag v-for="c in scope.row.categories" :key="c" size="small">{{ category_map[c] }}</el-tag>
                </template>
            </el-table-column>
            <el-table-column label="主要标签" prop="major_tags">
                <template #default="scope">
                    <el-tag v-for="t in scope.row.major_tags" :key="t" size="small">{{ major_map[t] }}</el-tag>
                </template>
            </el-table-column>
            <el-table-column label="来源" prop="source" width="120"></el-table-column>
            <el-table-column label="业务占用" width="130">
                <template #default="scope">
                    <el-tag v-if="scope.row.achievement_reward" type="danger" size="small">成就奖励</el-tag>
                    <span v-else style="color: #999;">无</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="110">
                <template #default="scope">
                    <el-button type="primary" size="small" :loading="scope.row._adding"
                               :disabled="loading || picker.loading || isDailyImage(scope.row.id) || scope.row.achievement_reward"
                               @click="addDailyImage(scope.row)">
                        {{ scope.row.achievement_reward ? '不可添加' : (isDailyImage(scope.row.id) ? '已添加' : '添加') }}
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            layout="total, sizes, prev, pager, next"
            :total="picker.total"
            :page-size="picker.query.limit"
            :current-page="picker.page"
            :page-sizes="[10, 50, 100]"
            @current-change="fetchPickerImages"
            @size-change="handlePickerPageSizeChange"
            :disabled="picker.loading"
            style="margin-top: 10px"
        ></el-pagination>
    </el-dialog>
</template>

<script>
import axios from "ts-axios-new";
import DateRangePicker from "../base/DateRangePicker";
import {ElMessage} from "element-plus";
import {buildDailyImagePickerParams} from "../libs/dailyImageWorkflow.mjs";

function apiError(e) {
    const m =
        e?.response?.data?.message ||
        e?.response?.data?.status?.message ||
        (typeof e?.response?.data === "string" ? e.response.data : null) ||
        e?.message;
    ElMessage.error(m || "请求失败");
}

export default {
    name: "Daily",
    components: {DateRangePicker},
    data() {
        return {
            loading: false, data: [], data_map: {}, dialog_opened: false, page: 1, size: 20,
            category_list: [], major_list: [], minor_list: [], assistant_list: [],
            category_map: {}, major_map: {}, minor_map: {}, assistant_map: {},
            picker: {
                opened: false,
                loading: false,
                images: [],
                total: 0,
                page: 1,
                requestId: 0,
                query: {
                    status: 'AUDITED',
                    module: 'LIBRARY',
                    unassigned_online_date: true,
                    include_achievement_usage: true,
                    is_animated: null,
                    id: '',
                    category_ids: [],
                    major_tags: null,
                    minor_tags: null,
                    assistant_tags: null,
                    skip: 0,
                    limit: 10,
                },
            },
            tagProps: {expandTrigger: 'hover', label: 'name', value: 'id', emitPath: false, multiple: true},
            form: {
                start: null,
                end: null,
            }
        }
    },
    methods: {
        moduleLabel(module) {
            return {LIBRARY: '图库', COLLECTION: '集合', DAILY: '每日', EVENT: '活动'}[module] || module || '未设置';
        },
        convertTagNames(list) {
            list.forEach(l => {
                l.name = l.i18n_name?.ZH_HANS || l.name;
                if (!l.children) {
                    l.children = [];
                }
                if (l.children.length) {
                    this.convertTagNames(l.children);
                }
            });
        },
        init() {
            this.loading = true;
            axios.get(`/cms/v1/daily`).then(res => {
                this.data = res.data.data.imageList;
                this.reload();
                this.loading = false;
            }).catch(e => {
                this.loading = false;
                apiError(e);
            })
        },
        reload() {
            this.data_map = {};
            this.data.forEach(image => {
                if (image.online_date && image.status === 'AUDITED') {
                    if (this.data_map[image.online_date]) {
                        this.data_map[image.online_date].push(image);
                    } else {
                        this.data_map[image.online_date] = [image];
                    }
                }
            })
        },
        update(row) {
            this.loading = true;
            axios.post(`/cms/v1/daily`, {date: row.online_date, image_id: row.id, desc: row.desc}).then(res => {
                this.reload();
                this.loading = false;
            }).catch(e => {
                this.loading = false;
                apiError(e);
            })
        },
        updateOnlineDate(row) {
          this.loading = true;
          axios.put(`/cms/v1/online/image/${row.id}`, { online_date: row.online_date}).then(res => {
            this.loading = false;
            this.reload();
          }).catch(e => {
            this.loading = false;
            apiError(e);
          })
        },
        openImagePicker() {
            this.picker.opened = true;
            this.fetchPickerImages(1);
        },
        buildPickerParams() {
            return buildDailyImagePickerParams(this.picker.query, this.picker.page);
        },
        fetchPickerImages(page) {
            this.picker.page = page;
            this.picker.loading = true;
            const requestId = ++this.picker.requestId;
            axios.get(`/cms/v1/image`, {params: this.buildPickerParams()}).then(res => {
                if (requestId !== this.picker.requestId) {
                    return;
                }
                this.picker.images = res.data.data.imageList;
                this.picker.total = res.data.data.total;
                this.picker.loading = false;
            }).catch(e => {
                if (requestId !== this.picker.requestId) {
                    return;
                }
                this.picker.loading = false;
                apiError(e);
            })
        },
        handlePickerPageSizeChange(size) {
            this.picker.query.limit = size;
            this.fetchPickerImages(1);
        },
        isDailyImage(imageId) {
            return this.data.some(i => i.id === imageId);
        },
        addDailyImage(row) {
            row._adding = true;
            axios.post(`/cms/v1/daily`, {image_id: row.id}).then(res => {
                const image = res.data.data;
                const idx = this.data.findIndex(i => i.id === image.id);
                if (idx === -1) {
                    this.data.unshift(image);
                } else {
                    this.data.splice(idx, 1, image);
                }
                row.module = 'DAILY';
                row._adding = false;
                this.reload();
                ElMessage.success('已添加到每日更新');
            }).catch(e => {
                row._adding = false;
                apiError(e);
            })
        },
        resourceUrl(resource) {
            if (!resource) {
                return '';
            }
            if (/^https?:\/\//.test(resource)) {
                return resource;
            }
            const cdn = import.meta.env.VITE_CDN_URL || 'https://jigsaw-cdn.plutodesk.com';
            return `${cdn.replace(/\/$/, '')}/${resource}`;
        },
        df(map, list) {
            list.forEach(l => {
                map[l.id] = l.i18n_name?.ZH_HANS || l.name;
                if (!l.children) {
                    l.children = [];
                }
                if (l.children.length) {
                    this.df(map, l.children);
                }
            });
        },
    },
    mounted() {
        this.loading = true;
        axios.all([
            axios.get(`/cms/v1/category`).then(res => {
                this.category_list = res.data.data.categoryList;
                this.category_list.forEach(c => {
                    this.category_map[c.id] = c.i18n_name.ZH_HANS;
                })
            }),
            axios.get('/cms/v1/tag/major').then(res => {
                this.major_list = res.data.data.tagList;
                this.convertTagNames(this.major_list);
                this.df(this.major_map, this.major_list);
            }),
            axios.get('/cms/v1/tag/minor').then(res => {
                this.minor_list = res.data.data.tagList;
                this.convertTagNames(this.minor_list);
                this.df(this.minor_map, this.minor_list);
            }),
            axios.get('/cms/v1/tag/assistant').then(res => {
                this.assistant_list = res.data.data.tagList;
                this.convertTagNames(this.assistant_list);
                this.df(this.assistant_map, this.assistant_list);
            }),
        ]).then(_ => {
            this.init();
        })
    },
    computed: {
        dataFilter() {
            return this.data.filter(d => {
                return !this.form.start && !this.form.end || this.form.start <= d.online_date && this.form.end >= d.online_date;
            })
        },
        dataPage() {
            return this.dataFilter.slice((this.page - 1) * this.size, this.page * this.size);
        },
    }
}
</script>

<style scoped>
.el-calendar ::v-deep(.el-calendar-day) {
    height: 100px;
}

.daily-toolbar {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-top: 20px;
}

.picker-filter {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}
</style>
